module.exports = __webpack_public_path__ + "img/g-logo-bw.0801f0f9.png";